// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as City$PorterinFeature from "../../../../shared/core/helpers/City.mjs";
import * as StringUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/StringUtils.mjs";
import * as UtmHelper$PorterinFeature from "../../../../shared/core/helpers/UtmHelper.mjs";
import * as CityConfig$PorterinFeature from "../../domain/repo/types/CityConfig.mjs";
import * as FormValidationUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.mjs";
import * as AnalyticsHelper$PorterinFeature from "../../../../shared/core/helpers/AnalyticsHelper.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as PartnersFormModuleScss from "../../view/styles/PartnersForm.module.scss";

var styles = PartnersFormModuleScss;

function getVehicleTypesParams(geo_region_id) {
  var dict = {};
  dict["geo_region_id"] = String(geo_region_id);
  dict["with_others"] = Pervasives.string_of_bool(true);
  return dict;
}

function encodeAttachVehicleForm(form_info) {
  var vendorQuery = {};
  vendorQuery["name"] = form_info.name;
  vendorQuery["mobile"] = form_info.mobile;
  vendorQuery["geo_region_id"] = form_info.city.id;
  vendorQuery["vehicle_id"] = form_info.vehicleType.id;
  vendorQuery["info_source"] = form_info.infoSource;
  vendorQuery["brand"] = "porter";
  var result = {};
  result["vendor_query"] = vendorQuery;
  return result;
}

function partnerCityToSelectConv(city) {
  return {
          key: String(city.id),
          value: city.name,
          text: city.name.toUpperCase()
        };
}

function partnerVehicleToSelectConv(vehicle) {
  return {
          key: String(vehicle.id),
          value: vehicle.name,
          text: vehicle.name.toUpperCase()
        };
}

function infoSourceToSelectConv(source) {
  return {
          key: source,
          value: source,
          text: StringUtils$Catalyst.snakeCaseToTitleCase(source).toUpperCase()
        };
}

function getKeyFromSelectOrBlank(select_item) {
  return Belt_Option.mapWithDefault(select_item, "", (function (req) {
                return req.key;
              }));
}

function getSelectComponentItems(items, convertor) {
  return List.map(convertor, items);
}

function cityToPartnerCity(city) {
  return {
          id: City$PorterinFeature.cityToGeoRegionId(city),
          name: city
        };
}

function validateMaxLength(length, name, instruction) {
  var num = name.length;
  if (num !== 0) {
    if (num > length) {
      return {
              TAG: /* Error */1,
              _0: "Maximum " + String(length) + " letters"
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: name
            };
    }
  } else {
    return {
            TAG: /* Error */1,
            _0: instruction
          };
  }
}

function validateMobileNumber(number) {
  var _error = FormValidationUtils$Catalyst.validateMobileNumber(number);
  if (_error.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: _error._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Enter valid mobile number"
          };
  }
}

function getBaseClassName(baseClassName) {
  switch (baseClassName) {
    case "modal-form-input city" :
        return styles["modal-form-input"] + " " + styles.city;
    case "modal-form-input mobile" :
        return styles["modal-form-input"] + " " + styles.mobile;
    case "modal-form-input name" :
        return styles["modal-form-input"] + " " + styles.name;
    case "modal-form-input vehicle" :
        return styles["modal-form-input"] + " " + styles.vehicle;
    default:
      return styles["modal-form-input"] + " " + styles["info-source"];
  }
}

function getInputClass(baseClassName, input) {
  if (Belt_Option.mapWithDefault(input, false, Belt_Result.isError)) {
    return getBaseClassName(baseClassName) + " " + styles["error-box"];
  } else {
    return getBaseClassName(baseClassName);
  }
}

function scrollToElement(ele) {
  return ele.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest"
            });
}

function getAttachVehicleEventLabel(name, mobile_number, vehicle_id, city_id) {
  var match = UtmHelper$PorterinFeature.getUtmString(undefined);
  return AnalyticsHelper$PorterinFeature.getNumberedEventLabel({
              hd: name,
              tl: {
                hd: mobile_number,
                tl: {
                  hd: vehicle_id,
                  tl: {
                    hd: city_id,
                    tl: {
                      hd: match[0],
                      tl: {
                        hd: match[1],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

function formEventHandler(category, action, name, mobile_number, vehicle_id, city_id) {
  PublishEventsHelper$PorterinFeature.publishEvents(category, action, getAttachVehicleEventLabel(name, mobile_number, vehicle_id, city_id));
}

function getInfoSourceList(param) {
  return {
          hd: "bus_ads",
          tl: {
            hd: "pamphlet",
            tl: {
              hd: "garage_hoarding",
              tl: {
                hd: "newspaper_ads",
                tl: {
                  hd: "driver_referral",
                  tl: {
                    hd: "customer_referral",
                    tl: {
                      hd: "channel_partner",
                      tl: {
                        hd: "others",
                        tl: {
                          hd: "fos",
                          tl: {
                            hd: "online/facebook",
                            tl: {
                              hd: "smart_shift",
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function getServicableCities(param) {
  return {
          hd: CityConfig$PorterinFeature.mumbai,
          tl: {
            hd: CityConfig$PorterinFeature.delhi_NCR,
            tl: {
              hd: CityConfig$PorterinFeature.bangalore,
              tl: {
                hd: CityConfig$PorterinFeature.hyderabad,
                tl: {
                  hd: CityConfig$PorterinFeature.chennai,
                  tl: {
                    hd: CityConfig$PorterinFeature.ahmedabad,
                    tl: {
                      hd: CityConfig$PorterinFeature.jaipur,
                      tl: {
                        hd: CityConfig$PorterinFeature.pune,
                        tl: {
                          hd: CityConfig$PorterinFeature.kolkata,
                          tl: {
                            hd: CityConfig$PorterinFeature.surat,
                            tl: {
                              hd: CityConfig$PorterinFeature.lucknow,
                              tl: {
                                hd: CityConfig$PorterinFeature.coimbatore,
                                tl: {
                                  hd: CityConfig$PorterinFeature.indore,
                                  tl: {
                                    hd: CityConfig$PorterinFeature.nagpur,
                                    tl: {
                                      hd: CityConfig$PorterinFeature.chandigarh,
                                      tl: {
                                        hd: CityConfig$PorterinFeature.vadodara,
                                        tl: {
                                          hd: CityConfig$PorterinFeature.ludhiana,
                                          tl: {
                                            hd: CityConfig$PorterinFeature.kochi,
                                            tl: {
                                              hd: CityConfig$PorterinFeature.nashik,
                                              tl: {
                                                hd: CityConfig$PorterinFeature.visakhapatnam,
                                                tl: {
                                                  hd: CityConfig$PorterinFeature.kanpur,
                                                  tl: /* [] */0
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

var getDefaultCity = "dubai";

export {
  styles ,
  getVehicleTypesParams ,
  encodeAttachVehicleForm ,
  partnerCityToSelectConv ,
  partnerVehicleToSelectConv ,
  infoSourceToSelectConv ,
  getKeyFromSelectOrBlank ,
  getSelectComponentItems ,
  cityToPartnerCity ,
  validateMaxLength ,
  validateMobileNumber ,
  getBaseClassName ,
  getInputClass ,
  scrollToElement ,
  getAttachVehicleEventLabel ,
  formEventHandler ,
  getInfoSourceList ,
  getServicableCities ,
  getDefaultCity ,
}
/* styles Not a pure module */
